export default __webpack_public_path__ + "static/media/Sanathan_Cover_Investor_Mar2025.926fe29d.pdf";